export default __webpack_public_path__ + "static/backgroundImage-min-dab386a3556ac2ab6caa28de5ed6f181.jpg";